import { Share, type IconProps } from "@phosphor-icons/react";

export function ShareIcon(props: IconProps) {
  return <Share size={24} weight="regular" {...props} />;
}
